import './index.css';
import { CSSProperties } from 'react';
import View from '../view';
import React from 'react';
interface Props {
  children: any;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}

const ScrollView = ({ children, style, className }: Props) => {
  return (
    <View style={style} className={`scroll-view-container ${className}`}>
      {children}
    </View>
  );
};
export default React.memo(ScrollView);
